import { useState, useEffect, useCallback } from 'react';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { SplashScreen } from 'src/components/loading-screen';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

/**
 * 总部管理员守卫
 *
 * 仅 tenantId === '0000' 且 isAdmin 的用户可访问（如租户管理）。
 * 须套在 AuthGuard、AdminGuard 之内。
 */
type HqGuardProps = {
  children: React.ReactNode;
};

export function HqGuard({ children }: HqGuardProps) {
  const router = useRouter();
  const { user, loading } = useAuthContext();

  const [isChecking, setIsChecking] = useState(true);

  const checkPermissions = useCallback(async (): Promise<void> => {
    if (loading) return;

    if (!user?.isAdmin) {
      router.replace(paths.dashboard.root);
      return;
    }

    setIsChecking(false);
  }, [loading, user?.isAdmin, router]);

  useEffect(() => {
    checkPermissions();
  }, [checkPermissions]);

  if (isChecking) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
